




export class McCard extends HTMLElement {

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    const template = document.createElement("template")
    template.innerHTML = `
<link rel="stylesheet" href="mache.css">
<style>
  :host {
    border-width: 1px;
    border-color: hsl(var(--mc-text)/.1);
    padding: 1rem;
    border-style: solid;
    display: block;
    border-radius: 10px;
    background-color: hsl(var(--mc-surface));
  }

</style>
<slot></slot>
`
    this.shadowRoot.append(template.content.cloneNode(true))
  }


  static get observedAttributes() {
    return ["borw", "borcolor", "bgcolor"]
  }



  attributeChangedCallback(name, ov, nv) {
    switch (name) {
      case "borw":
        this.style.borderWidth = nv;
        break;
      case "borcolor":
        this.style.borderColor = nv
        break;
      case "bgcolor":
        this.style.backgroundColor = nv
        break;
    }
  }


  connectedCallback() {
  }


}

if (!window.customElements.get("mc-card"))
  window.customElements.define("mc-card", McCard)
